import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';
import type { HierarchyDTO } from './useGetHierarchies';
import type { HierarchyPayload } from './useCreateHierarchy';

export const useUpdateHierarchy = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({
			hierarchyId,
			...payload
		}: HierarchyPayload & { hierarchyId: string }) => {
			try {
				const { data } = await api.put<HierarchyDTO>(`/hierarchy/update/${hierarchyId}`, payload);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao atualizar hierarquia');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['hierarchies'] });
			queryClient.invalidateQueries({ queryKey: ['hierarchy'] });
		},
	});
};
